// Service for calendar API
export default class CalendarsService {
  static async updateCalendar(id, calendar, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/calendars/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(calendar),
    });
    if (!response.ok) throw new Error('Failed to update calendar');
    return response.json();
  }
  static async fetchCalendars(token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/calendars`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch calendars');
    return response.json();
  }

  static async createCalendar(calendar, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/calendars`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(calendar),
    });
    if (!response.ok) throw new Error('Failed to create calendar');
    return response.json();
  }

  static async deleteCalendar(id, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/calendars/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to delete calendar');
    return true;
  }

  static async fetchCalendar(id, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/calendars/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch calendar');
    return response.json();
  }
}
